<script setup>

</script>

<template>
    <svg
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M21 12a9 9 0 1 1-9.5-8.99a3 3 0 0 0 3.5 3.5a3 3 0 0 0 3.5 3.5A3 3 0 0 0 21 12z"/>
        <circle cx="8" cy="9.5" r="1" fill="currentColor" stroke="none"/>
        <circle cx="12" cy="12" r="0.75" fill="currentColor" stroke="none"/>
        <circle cx="9" cy="15.5" r="1" fill="currentColor" stroke="none"/>
        <circle cx="15" cy="15.5" r="1" fill="currentColor" stroke="none"/>
    </svg>
</template>
